import p5 from "p5";
import { View } from "./views/View";

export class GameView {
    public p: p5;
    public current_view: View | null;

    constructor(p: p5) {
        this.p = p;
        this.current_view = null;
    }

    public set_view(view: View): View {
        if (this.current_view) this.current_view.unload();
        this.current_view = view;
        this.current_view.load();
        return view;
    }

    public draw() {
        if (this.current_view) {
            this.current_view.draw();
        }
    }
}